<app-navbartwo></app-navbartwo>
  <section class="feat_main_bg">
    <div class="container">
      <!-- section of the page in header section2 -->
      <div class="row" style="padding-bottom: 40px;">
        <div class="col-md-5">
          <div class="banner_right">
          <h5 class="banner_text_main">Successful <br> E-Commerce <br>
          Business</h5>
           <p class="section_top">
            MCred Pro helps you not just manage your online store
            but also make it hugely successful. Effectively, efficiently
            and effortlessly from anywhere in the world!

           </p>
           </div>
        </div>
        <div class="col-md-7">
          <div>
            <img src="../../assets/images/fea_1.png" alt="video_image" class="video_image">
          </div>
      </div>
      </div>
      <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#0099ff" fill-opacity="1" d="M 50 200 Q 100 300 250 300 Q 600 250 750 200 "></path>
      </svg> -->
    </div>
  </section>
  <!-- section of the page in header section2 End -->
  <section style="background-color: white;padding-top:45px;padding-bottom: 25px;">
    <img src="../../../assets/images/animation2_right_s3.png" alt="animation2_right" class="animation2_right">
    <div class="container">
      <div class="row">
        <p class="text-center1">
          A successful business has robust and structured features at its crux. We at MCred Pro provide you customized
          features to manage your online store successfully.Of the many, features include catalog management, unlimited
          product list, order management, reviews and ratings, key business metrics using interactive dashboard.
         Now, with us, you can successfully manage your entire store in one e-commerce platform, with just one click.

        </p>
      </div>
      <div class="row">
        <div class="col-lg-6">
            <img src="../../assets/images/fea_2.png" alt="section2_image" class="lappiimage_main"/>
          <!-- <div class="col-md-6 section3_maintext">
             <p class="sectionp sectionpext">
              A successful business has robust and structured features at its crux. We at MCred Pro
               provide you customized features to manage your online store successfully. Of the many,
               features include catalog management, unlimited product list, order management, reviews and
               ratings, key business metrics using interactive dashboard.<br>
              <br>
              Now, with us, you can successfully manage your entire store in one e-commerce platform,
              with just one click.

             </p>
         </div> -->
        </div>
        <div class="col-lg-6">
         <div class="row" style="padding-bottom: 10px;">
           <div class="col-md-6">
            <img src="../../../assets/images/fea_3.png" alt="explore_image11" class="explore_image11">
            <h5 class="explore_h51">Interactive Dashboard</h5>
            <p class="explore_p1">Gives you a quick insight of key elements of your business. It helps you keep track of your day-to-day business activities like latest orders, inventory, sales, customers etc.</p>
           </div>
           <div class="col-md-6">
            <img src="../../../assets/images/fea_4.png" alt="explore_image11 explore_gap" class="explore_image11">
            <h5 class="explore_h51">Catalog Management</h5>
      <p class="explore_p1">The perfect way to list your categorized products with unlimited images and details. You can choose what you want to list; price, size, colour, fit and create your own sub-categories to suit your needs.</p>
          </div>
         </div>
         <div class="row" style="padding-bottom: 10px;">
          <div class="col-md-6">
            <img src="../../../assets/images/fea_5.png" alt="explore_image11" class="explore_image11">
            <h5 class="explore_h51">Order Management</h5>
        <p class="explore_p1"> Keep track of and manage the inventory effectively with specified access. You can decide who can view, edit order details and track the shipment status of every purchase.
        </p>
          </div>
          <div class="col-md-6">
            <img src="../../../assets/images/fea_6.png" alt="explore_image11" class="explore_image11">
            <h5 class="explore_h51">Review and Ratings</h5>
            <p class="explore_p1">Reviews and ratings are the utmost critical angle of any business. Reviews are what many buyers read, to decide to shop. Manage your R n R and know what your customers want; and keep it in stock depending on the trend analysis.
            </p>
         </div>
        </div>
        <div class="row" style="padding-bottom: 10px;">
          <div class="col-md-6">
            <img src="../../../assets/images/fea_7.png" alt="explore_image11" class="explore_image11">
              <h5 class="explore_h51">Manage Reports</h5>
            <p class="explore_p1">Reports help you gauge what is popular and why. Be ahead of your customers’ needs by reviewing your reports. They help keep track of the performance while giving a snapshot of orders, sales and customer base.
            </p>
          </div>
          <div class="col-md-6">
            <img src="../../../assets/images/fea_8.png" alt="explore_image11" class="explore_image11">
            <h5 class="explore_h51">Manage Coupons</h5>
            <p class="explore_p1">Coupons are always an added attraction that never fail to entice customers. They will help bring in extra customers without spending much. Decide a fixed value or date and you are set to start the ball rolling.
             </p>
         </div>
        </div>
        </div>
     </div>
    </div>
  </section>
  <!-- section of the page in header section6  -->
  <section class="reviews_imagebg" style="padding-top: 1px;">
    <div class="container">
          <div class="row" style="padding-bottom: 40px;padding-top: 40px;">
          <div class="col-md-5 section3_maintext" style="color:white!important;">
            <h5 class="banner_text_main" style="margin-top:30%;">Sell Everything, Everywhere!</h5>
               <p class="section_top">
                Anything, Anywhere, Anytime!<br>
                MCred gets your store online to sell just about anything and everything.
                It will make your  presence be felt!
               </p>
         </div>
         <div class="col-md-7">
          <img src="../../../assets/images/fea_16.png" alt="section2_image" class="section2sets_image"/>
        </div>
         </div>
    </div>
  </section>
  <!-- section of the page in header section6  End-->
 <!-- section of the page in header section2 End -->
 <section style="background-color: white;padding-top:15px;">
  <div class="container">
    <div class="row">
      <img src="../../../assets/images/animation2_right_s3.png" alt="animation2_right" class="animation2_right">
      <div class="col-md-6">
        <img src="../../assets/images/fea_9.png" alt="section2_image" class="lappiimage_main"/>
      </div>
      <div class="col-md-6 section3_maintext">
         <p class="sectionp sectionpext sectionpext23">
          Create, Curate, Check! <br>
          <br>
          You can now create your store online, manage it, upload products, check reports and
          much more from just about anywhere, being at the top of it all!
          <br>
          <br>
          It is as simple as that; create as per your requirement, curate as per the trends, check the
           status and be abreast with what’s happening. It will help you keep a keen tab on the nitty-gritties
            to make your business a huge success.
         </p>
     </div>
   </div>
  </div>
</section>

<!-- section of the page in header section8  -->
<section style="    background-color: white;
padding-top: 20px;padding-bottom: 40px;">
  <div class="container">
      <div class="planning_topdiv">

      <div class="row">
        <div class="col-md-4 boxshadesh sideline_section">
         <div>
           <div class="explore_box">
            <img src="../../../assets/images/fea_10.png" alt="explore_image1" class="explore_image1">
           </div>
           <h5 class="explore_h5">E-store</h5>
           <p class="explore_p">MCred is the one-stop place to sell anything online. It’s easy, it’s fast and it’s the best.</p>
         </div>
        </div>
        <div class="col-md-4 boxshadesh sideline_section">
          <div class="dot"></div>
          <div class="explore_box">
            <img src="../../../assets/images/fea_11.png" alt="explore_image1" class="explore_image2">
           </div>
           <h5 class="explore_h5">Brands</h5>
           <div class="dot2"></div>
           <p class="explore_p">Make your brand your own unique identity. One that becomes a name to reckon with!</p>
        </div>
        <div class="col-md-4 boxshadesh">
          <div class="dot11"></div>
          <div class="explore_box">
            <img src="../../../assets/images/fea_12.png" alt="explore_image1" class="explore_image3">
           </div>
           <h5 class="explore_h5">Shopping Experience</h5>
           <p class="explore_p">Enhance your customers shopping experience. Flexible shopping, easy returns, attractive offers.
           </p>
        </div>
      </div>


      <div class="row">
        <div class="col-md-4 boxshadesh sideline_section">
         <div>
           <div class="explore_box">
            <img src="../../../assets/images/fea_13.png" alt="explore_image1" class="explore_image123">
           </div>
           <h5 class="explore_h5">User-Friendly Software</h5>
           <p class="explore_p">Get a customized, efficient and seamless online store.
             Well organized and easy to use too.
           </p>
         </div>
        </div>
        <div class="col-md-4 boxshadesh sideline_section">

          <div class="explore_box">
            <img src="../../../assets/images/fea_14.png" alt="explore_image1" class="explore_image2">
           </div>
          <h5 class="explore_h5">Products</h5>
          <div class="dot2"></div>
          <p class="explore_p">Curate and provide personalized inputs to individual customers, based on shopping trends.
          </p>
        </div>
        <div class="col-md-4 boxshadesh">
          <div class="dot11"></div>
          <div class="explore_box">
            <img src="../../../assets/images/fea_15.png" alt="explore_image1" class="explore_image3">
           </div>
          <h5 class="explore_h5">Easy Checkout</h5>
          <p class="explore_p">Provide hassle free, simple yet secure platform for all transactions, which is the need of the hour.
          </p>
        </div>
      </div>
      </div>
  </div>
</section>
<!-- section of the page in header section8  End-->

   <!-- section of the page in header section8  -->
   <!-- <section class="section_white_bg">
    <div class="container">
      <div class="message_box" >
        <div class="row">
          <div class="planning_topdivss">
          <h4 class="h4_heading" style="color:#fff">Start Your Business with MCred</h4>
          <button class="getstarted_button">Get Started</button>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <!-- section of the page in header section8  End-->
<app-footer></app-footer>
